import React from 'react';
import { downloadFile } from  '../../../Globals/Utils/fileDownload';

interface ActionLinksProps {
  url: string;
  label: string;
  onViewPdf: (url: string) => void;
}

export const ActionLinks: React.FC<ActionLinksProps> = ({ url, label, onViewPdf }) => (
  <div className="flex space-x-3 mt-2">
    <button 
      className="m-2 btn-azul transition-colors"
      onClick={(e) => {
        e.preventDefault();
        onViewPdf(url);
      }}
      aria-label={`Ver ${label}`}
    >
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2.5" stroke="currentColor" className="w-5 h-5">
        <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
      </svg>
    </button>
    <button 
      className="m-2 btn-azul transition-colors" 
      onClick={(e) => {
        e.preventDefault();
        downloadFile(url, label);
      }}
      aria-label={`Descargar ${label}`}
    >
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2.5" stroke="currentColor" className="w-5 h-5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v12m0 0l-3.75-3.75M12 16.5l3.75-3.75" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 19.5h16.5" />
      </svg>
    </button>
  </div>
);